import { Routes, Route, Navigate } from 'react-router-dom';
import { Shell } from '@/components/layout';
import {
  AcademyPage,
  CommunityPage,
  LaunchPadPage,
  SupportPage,
  ShopPage,
  PortfolioPage,
  LibraryPage,
  MarketplacePage,
  BookingPage,
  HomePage,
  DashboardPage,
  SettingsPage,
  NotFoundPage,
} from '@/pages';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import CookiePolicyPage from '@/pages/CookiePolicyPage';
import { LoginPage } from '@/pages/LoginPage';
import { AppsPage } from '@/pages/AppsPage';
import { AppDetailPage } from '@/pages/AppDetailPage';
import { AuthProvider, ProtectedRoute } from '@/features/auth/components';
import { ConsentProvider } from '@/features/consent/components/ConsentProvider';

/**
 * Root application component with router configuration
 */
function App() {
  return (
    <ConsentProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<LoginPage />} />
          <Route path="/data-protection" element={<PrivacyPolicyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<Shell />}>
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="/academy/*" element={<AcademyPage />} />
              <Route path="/community/*" element={<CommunityPage />} />
              <Route path="/launchpad/*" element={<LaunchPadPage />} />
              <Route path="/support/*" element={<SupportPage />} />
              <Route path="/shop/*" element={<ShopPage />} />
              <Route path="/portfolio/*" element={<PortfolioPage />} />
              <Route path="/marketplace/*" element={<MarketplacePage />} />
              <Route path="/library/*" element={<LibraryPage />} />
              <Route path="/booking/*" element={<BookingPage />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/apps" element={<AppsPage />} />
              <Route path="/apps/:appId" element={<AppDetailPage />} />
            </Route>
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </ConsentProvider>
  );
}

export default App;
